<template>
  <el-select
    v-model="selectedCountry"
    placeholder="Select country"
    @change="$emit('change', selectedCountry)"
  >
    <el-option
      v-for="country in countries"
      :key="country"
      :label="country"
      :value="country"
    >
    </el-option>
  </el-select>
</template>

<script>
export default {
  data() {
    return {
      countries: ["Nigeria"],
      selectedCountry: null,
    };
  },
};
</script>

<style></style>
